/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-06 16:33:23
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-06-08 14:27:32
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/components/RadioTopic/RadioContent.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineComponent, reactive, watch } from '@vue/composition-api'
import _ from 'lodash'
import './index.scss'
import { INPUT_VALUE_TYPE_RULE } from '../../config'
import { blurInput } from '../../topicCommonUtil'
import { getRandomList } from '@/pages/Survey/SurveyManagement/components/SurveyContent/topicCommonUtil'
import { number } from 'echarts'
import VueI18n from 'vue-i18n'
const RadioContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    i18n: {
      type: VueI18n
    },
    isViewAnswer: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { emit } = context

    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })

    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )

    const radioInput = (value) => {
      if (props.isViewAnswer) return
      state.editItem.value = value
      state.editItem.inputErrorTips = ''
      state.editItem.isShowInputError = false
      state.editItem.isShowTitleError = false
      state.editItem.inputValue = ''

      let options = state.editItem.topicSetting.topicOptionSetting
      options.forEach((element) => {
        state.editItem['inputErrorTips_' + element.optionId] = ''
      })

      emit('answer', state.editItem)
    }

    const focusInput = (value, sitem) => {
      let options = state.editItem.topicSetting.topicOptionSetting
      options.forEach((element) => {
        state.editItem['inputErrorTips_' + element.optionId] = ''
      })
      state.editItem.value = sitem.optionId
      emit('answer', state.editItem)
    }

    const inputChange = (value, sitem) => {
      state.editItem['inputValue_' + sitem.optionId] = value
      emit('answer', state.editItem)
    }

    const blurRadioInput = (value, sitem, state, emit) => {
      blurInput(value, sitem, state, emit)
    }

    return () => {
      return (
        <div class="radio-topic-content">
          <el-radio-group
            class="el-radio-group-content"
            value={state.editItem.value}
            onInput={(value) => radioInput(value)}>
            {(props.item.topicSetting.topicOptionSetting || []).map((sitem) => {
              return (
                <div
                  class={{
                    'radio-item-contain-input': !!sitem.isAddText,
                    'el-radio-item': true
                  }}>
                  <el-radio label={sitem.optionId}>
                    <div>
                      <span domPropsInnerHTML={sitem.optionName}></span>
                      <span class="el-radio-error">
                        {state.editItem['inputErrorTips_' + sitem.optionId]}
                      </span>
                    </div>
                    {sitem.isAddText &&
                      state.editItem.value === sitem.optionId && (
                        <div class="radio-item-box">
                          {!props.isViewAnswer && (
                            <el-input
                              type="textarea"
                              autosize={{ minRows: 1, maxRows: 5 }}
                              maxlength="1000"
                              show-word-limit
                              onfocus={(value) => focusInput(value, sitem)}
                              onblur={(value) =>
                                blurRadioInput(value, sitem, state, emit)
                              }
                              value={
                                state.editItem['inputValue_' + sitem.optionId]
                              }
                              onInput={(value) => inputChange(value, sitem)}
                              class="radio-item-input"
                              size="small"
                              placeholder={props.i18n?.t(
                                'survy.plccontent'
                              )}></el-input>
                          )}
                          {props.isViewAnswer && (
                            <el-tooltip
                              placement="bottom"
                              disabled={
                                !state.editItem['inputValue_' + sitem.optionId]
                              }
                              content={
                                state.editItem['inputValue_' + sitem.optionId]
                              }>
                              <el-input
                                type="textarea"
                                autosize={{ minRows: 1, maxRows: 5 }}
                                maxlength="1000"
                                show-word-limit
                                value={
                                  state.editItem['inputValue_' + sitem.optionId]
                                }
                                onInput={(value) => {}}
                                class="radio-item-input"
                                size="small"
                                placeholder={props.i18n?.t(
                                  'survy.plccontent'
                                )}></el-input>
                            </el-tooltip>
                          )}
                        </div>
                      )}
                  </el-radio>
                </div>
              )
            })}
          </el-radio-group>
        </div>
      )
    }
  }
})
export default RadioContent
